import {GameInfo} from '../games/game-info';
import React from "react";
import {Nullable} from "../../../common/types/nullable-types";

export interface IFiltersGroup {
  text: string;
  filters: ActiveFilter[];
  isMultiSelect: boolean;
}

export interface ActiveFilter {
  readonly id: string;
  readonly text: string;
  readonly on: boolean;
  readonly isDynamic: boolean;
}



export enum FilterIndicatorRenderingLocation {
  BelowArenaTitle,
  NextToArenaTitle
}
export interface IFilterIndicatorRenderingOptions {
  reactElement: React.ReactElement;
  location: FilterIndicatorRenderingLocation;
}

export interface IGamesFilterService {

  readonly filteredGamesMap: Record<string,GameInfo>;
  readonly isFilterOn: boolean;
  readonly currentAppliedFiltersIds: string[];
  readonly isFilteringAvailable: boolean;
  isFilterApplied(filterId: string): boolean;
  applyFilters(filterIds: string[]): Promise<void>;
  clearFilters(): Promise<void>;
  renderMobileFiltersIndicator(): React.ReactElement;
  renderFiltersIndicator(): Nullable<IFilterIndicatorRenderingOptions>;
  showFiltersEditor(): void;
  getNumberOfGamesBeforeUserApply(filterIDS: string[]): number;
}
